var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload pointer"},[_c('input',{ref:"fileUpload",staticClass:"fileUpload",attrs:{"type":"file","name":"file","title":" ","id":"fileUpload","accept":".xls,.xlsx"},on:{"change":_vm.fileChange}}),_c('a',{staticClass:"uploadButton",attrs:{"href":"javascript:;"},on:{"click":_vm.getFile}},[_vm._v(_vm._s(_vm.$t("luckDaw.上传名单")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }